module.exports = __webpack_public_path__ + "img/art-time-icon1.8a1d0278.png";